import { DOCUMENT, WINDOW } from "constants/environment"
import noScroll from "no-scroll"
import { noop, applyTransform, clearTransform } from "../../utils"

class Body {
  constructor() {
    this.locked = false
    WINDOW.__body = false
    if (!DOCUMENT) {
      ["lock", "unlock", "padBottom", "slide"].forEach((fn) => {
        this[fn] = noop
      })
    } else this.body = DOCUMENT.body
  }
  lock(top) {
    if (top) {
      WINDOW.scrollTo(0, 0)
    }
    noScroll.on()
    WINDOW.__body = true
    this.locked = true
  }
  unlock(scrollY = 0) {
    // IE 11 strikes again, ignores null, clear with ''
    noScroll.off()
    this.locked = false
    WINDOW.__body = false
    scrollY && WINDOW.scrollTo(0, scrollY)
  }
  padBottom(height) {
    this.body.style.paddingBottom = height
  }
  slide(translations) {
    // ie 11 does not like calc in transform values, so we use a combination of transforms
    // see http://stackoverflow.com/a/21469557
    if (!translations || !translations.length) {
      this.body.style.overflowX = "inherit"
      return clearTransform(this.body)
    }

    this.body.style.overflowX = "initial"

    if (typeof translations === "string") {
      return applyTransform(`translateX(calc(-100vw ${translations}))`, this.body)
    }

    return applyTransform(
      ["-100vw"]
        .concat(translations)
        .map(t => `translateX(${t})`)
        .join(" "),
      this.body
    )
  }
}

const body = WINDOW && new Body()

export default body



// WEBPACK FOOTER //
// ./src/containers/body/index.js